import LRouterTabs from './LRouterTabs'

export default LRouterTabs
export { LRouterTabs }
